const zoomIcon =
  'path://M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z';

const zoomResetIcon =
  'path://M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8zm-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91z';
export const defaultGraphicOptions = {
  grid: {
    left: '3%',
    right: '7%',
    bottom: '7%',
    containLabel: true,
  },
  tooltip: {
    showDelay: 0,
    formatter({ value }: { value: [number, number, string] }) {
      return `Date and time:<br/> ${value[2]}`;
    },
    axisPointer: {
      show: true,
      type: 'cross',
      lineStyle: {
        type: 'dashed',
        width: 1,
      },
    },
  },
  toolbox: {
    feature: {
      dataZoom: {
        icon: { zoom: zoomIcon, back: zoomResetIcon },
      },
      saveAsImage: {},
    },
  },
};
